import React, { Component } from 'react'
import { deepSetTrue } from 'shared/helpers/functional'
import CollapsibleSteps from 'containers/project-creation/create-view/collapsible-steps'
import StepOne from 'containers/project-creation/create-view/step-one'
import { notEmptyOrNil } from 'shared/helpers/functional'
import { axiosInstance } from 'network/apis'

class CreateInquiryForm extends Component {

  constructor (props) {
    super(props)

    this.errorBannerRef = React.createRef()
    this.formRef = React.createRef()
    this.state = {
      clientsList: [],
      salesForceJobNumbersList: []
    }
  }

  getClientsList = async () => {
    const result = await axiosInstance.get(`salesforce/clients`, { handlerEnabled: true })
    console.log("result client", result)
    return result
  }

  getSalesforceJobNbs = async (clientId) => {
    const result = await axiosInstance.get(`salesforce/projects/${clientId}`, { handlerEnabled: true })
    console.log("result salesforceJobNbs ", result)
    return result
  }

  componentDidMount () {
    const touchedObject = deepSetTrue(this.props.values)
    this.props.setTouched(touchedObject)
    this.getClientsList().then(res => this.setState({clientsList: res.data.data})).catch(e => {
      console.log("an error occured while getting clients list ", e);
      this.props.showSnackbarMessageError("An error occured while getting clients list")
      this.props.hideSnackbarMessage()
    })
  }

  warningText = "We found one or more required fields that are incomplete. They are highlighted below."

  isCompleted = (names, touched, errors) => names.every(name => touched[name] && !errors[name])

  scrollTop = () => {
    this.errorBannerRef.current.scrollIntoView()
  }

  scrollOnNext = () => {
    this.formRef.current.scrollIntoView()
  }

  onClientChange = (value) => {
    this.props.setFieldValue('salesForceClientId', value)
    this.props.setFieldValue('salesForceJobNumber', '')
    this.getSalesforceJobNbs(value).then(res => this.setState({salesForceJobNumbersList: res.data.data})).catch(e => {
      console.log("an error occured while getting salesforce job numbers list ", e);
      this.props.showSnackbarMessageError("An error occured while getting salesforce job numbers list")
      this.props.hideSnackbarMessage()
    })
  }

  render () {
    return (
      <React.Fragment>
        {notEmptyOrNil(this.props.errors) &&
          this.props.submitCount > 0 &&
          <div className="error-banner" ref={this.errorBannerRef}>
            <i className="im-warning"/>
            {this.warningText}
          </div>
        }
        <form onSubmit={this.props.handleSubmit} ref={this.formRef}>
          <CollapsibleSteps
            scrollOnNext={this.scrollOnNext}
          >
            <StepOne
              values={this.props.values}
              setFieldValue={this.props.setFieldValue}
              setFieldTouched={this.props.setFieldTouched}
              errors={this.props.errors}
              touched={this.props.touched}
              showErrors={this.props.submitCount > 0}
              isCompleted={this.isCompleted(['name', 'topicName' ,'interviewLength', 'sampleSize', 'salesForceJobNumber', 'salesForceClientId' ,'surveyId' ,'postScreeninBuffer'], this.props.touched, this.props.errors)}
              submitting={this.props.submitting}
              clientsList={this.state.clientsList}
              salesForceJobNumbersList={this.state.salesForceJobNumbersList}
              onClientChange={this.onClientChange}
              />
          </CollapsibleSteps>
        </form>
      </React.Fragment>
    )
  }
}


export default CreateInquiryForm
